<template lang="pug" src="./custom-meet-team.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      a: 0,
      b: 5,
      c: 6,
      activeTab: 'team1'
    }
  },
  methods: {
    activate (num) {
      if (num < 3) {
        this.a = num
      } else if (num < 6) {
        this.b = num
      } else {
        this.c = num
      }
    }
  },
  created () {
    if (screen.width < 500) {
      this.a = false
      this.b = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-meet-team.vue?39cd8554